import { createSlice } from "@reduxjs/toolkit";
import { getCustomersDetailsAPI } from "../../api/customer";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getCustomersDetailsSlice = createSlice({
  name: "getCustomersDetails",
  initialState: data,
  reducers: {
   getCustomersDetailsSlice(state) {
      state.isLoading = true;
    },
   getCustomersDetailsSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getCustomersDetailsSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getCustomersDetailsSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getCustomersDetailsHandler = (id:any) => async (dispatch: any) => {
  try {
    dispatch(getCustomersDetailsAction.getCustomersDetailsSlice());
    const response: any = await getCustomersDetailsAPI(id);
    
    dispatch(getCustomersDetailsAction.getCustomersDetailsSliceSuccess(response));
  } catch (e: any) {
    dispatch(getCustomersDetailsAction.getCustomersDetailsSliceFailure(e?.response?.data));
  }
};
export default getCustomersDetailsSlice.reducer;
export const getCustomersDetailsAction = getCustomersDetailsSlice.actions;
